import { z } from "zod";
import { extendZodWithOpenApi } from "zod-openapi";
import { jsonBody, successResponse, tagPaths } from "../util.ts";
import * as params from "./params.ts";
import { PricingList, ScheduledPricingBody } from "./pricing.ts";

extendZodWithOpenApi(z);

export const PricingHistory = z.record(PricingList).openapi({ ref: "PricingHistory" });

export const pricingAdminPaths = tagPaths("admin_pricing")({
    "/pricing/list": {
        get: {
            summary: "Get pricing history",
            responses: {
                ...successResponse(PricingHistory),
            },
        },
    },
    "/pricing/list/{id}": {
        put: {
            summary: "Set scheduled prices",
            description:
                "Replace the full price list for the specified month. Only the current month and future months can be changed.",
            parameters: [params.id],
            requestBody: jsonBody(ScheduledPricingBody),
            responses: {
                ...successResponse(PricingList),
            },
        },
        delete: {
            summary: "Delete scheduled prices",
            description: "Delete the scheduled price list for the specified month.",
            parameters: [params.id],
            responses: { ...successResponse(z.boolean()) },
        },
    },
});
